import InvestLayout from '../views/invests/Index'
import InvestList from '../views/invests/List'
import InvestEdit from '../views/invests/Edit'
import InvestShow from '../views/invests/Show'
import Permissions from '@/permissions'

export const investRouters = {
  path: 'invest',
  component: InvestLayout,
  redirect: '',
  meta: {
    permissions: [Permissions.backend.invest.manage],
    groups: 'invest'
  },
  children: [
    {
      path: '',
      name: 'Invest',
      component: InvestList,
      meta: {
        permissions: [Permissions.backend.invest.list],
        groups: 'invest',
        breadcrumb: [
          {
            name_en: 'Invest',
            name_km: 'វិនិយោគ'
          },
          {
            name_en: 'List',
            name_km: 'បញ្ជី'
          }
        ]
      }
    },
    {
      path: 'edit/:id',
      name: 'InvestEdit',
      component: InvestEdit,
      meta: {
        permissions: [Permissions.backend.invest.edit],
        groups: 'invest',
        breadcrumb: [
          {
            name_en: 'Invest',
            name_km: 'វិនិយោគ'
          },
          {
            name_en: 'Edit',
            name_km: 'កែសម្រួល'
          }
        ]
      }
    },
    {
      path: 'show/:id',
      name: 'InvestShow',
      component: InvestShow,
      meta: {
        permissions: [Permissions.backend.invest.show],
        groups: 'invest',
        breadcrumb: [
          {
            name_en: 'Invest',
            name_km: 'វិនិយោគ'
          },
          {
            name_en: 'Show',
            name_km: 'មើល'
          }
        ]
      }
    }
  ]
}
